export enum CoberturaJovem {
  USO_ATE_2_DIAS = "USO_ATE_2_DIAS",
  USO_MAIS_2_DIAS = "USO_MAIS_2_DIAS",
  NAO = "NAO",
  NAO_SE_APLICA = "NAO_SE_APLICA",
}
